import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { tApi } from "@/lib/api";

const TenantContext = createContext({ slug: "", info: null, api: null });

export const TenantProvider = ({ children }) => {
  const { slug } = useParams();
  const [info, setInfo] = useState(null);
  const api = useMemo(() => (slug ? tApi(slug) : null), [slug]);

  useEffect(() => {
    if (!api) return;
    api.publicInfo().then(setInfo).catch((e) => {
      console.error("TenantProvider: publicInfo failed", e);
      setInfo(null);
    });
  }, [api]);

  const value = useMemo(() => ({ slug, info, api }), [slug, info, api]);

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};

export const useTenant = () => useContext(TenantContext);
